export default "__VITE_ASSET__DiuY9b46__"